import { css } from "@emotion/css";
import { borderWidth, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";

export const tableBorder = `${borderWidth[1]} solid ${themeTokens.color.border.primary}`;

export const tableStyles = css({
    width: "100%",
    backgroundColor: themeTokens.color.background.primary.default,
    borderSpacing: 0,
    th: {
        padding: space[16],
        textAlign: "left",
        font: text.body.regular.medium,
        position: "relative",
        ":not(:first-child)": {
            ":before": {
                content: "''",
                position: "absolute",
                height: "50%",
                left: 0,
                top: "25%",
                borderLeft: tableBorder,
            },
        },
    },
    td: {
        borderTop: tableBorder,
        font: text.body.regular.medium,
        padding: space[16],
        verticalAlign: "middle",
    },
});

export const tableMobileStyles = css({
    display: "block",
    overflowX: "auto",
});
